<section class="musica mt-4 mb-4" id="musica">
    <div class="container">
      <h2 class="text-center animate__animated animate__fadeIn">Nuevo Videoclip</h2>
      <div class="musica-content">
        <p>Escucha nuestro último lanzamiento en las principales plataformas.</p>
        
        <div class="youtube-player">
            <iframe width="100%" height="500px" style="border-radius:12px" src="https://www.youtube.com/embed/KKCw7GMvctE?si=kfBamyXdV8VTiTkJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div class="spotify-player">
            <iframe style="border-radius:12px" src="https://open.spotify.com/embed/artist/2yRSIO9AuKlZHOwK5StQEx?utm_source=generator&theme=0" width="100%" height="500" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
        </div>
      </div>
    </div>
  </section>